import { useSectionStore } from '../store/Section';
import { useSectionRender } from '../utils/useRender';
export var Copied = props => {
  var {
    Copied: Comp = {}
  } = useSectionStore();
  useSectionRender(Comp, props, 'Copied');
  return null;
};
Copied.displayName = 'JVR.Copied';